import { ACCESS_PAYLOAD_KEY, BASE_API_PREFIX, BASE_API_URL } from "../constants/defaultValue.js";

export const streamAskQuestionPOST = async (data, onMessage, onError, onComplete) => {
  try {
    const headers = {
      "Content-Type": "text/event-stream",
      Accept: "text/event-stream",
    };

    // Add authentication headers
    const accessToken = localStorage.getItem(ACCESS_PAYLOAD_KEY);
    if (accessToken) {
      headers[ACCESS_PAYLOAD_KEY] = accessToken;
    }

    const managerAccessToken = sessionStorage.getItem("manager_access_token");
    if (managerAccessToken) {
      headers["ManagerAccessToken"] = managerAccessToken;
    }

    const sessionToken = sessionStorage.getItem("session_token");
    if (sessionToken) {
      headers["sSMid"] = sessionToken;
    }

    const business = sessionStorage.getItem("business");
    const url = new URL(`${BASE_API_URL}/${BASE_API_PREFIX}/question/stream-ask`);
    if (business) {
      url.searchParams.append("business", business);
    }

    const response = await fetch(url.toString(), {
      method: "POST",
      headers,
      body: JSON.stringify(data),
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    try {
      while (true) {
        const { done, value } = await reader.read();

        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n\n");
        buffer = lines.pop() || "";

        for (const line of lines) {
          if (line.trim()) {
            try {
              const dataMatch = line.match(/^data:\s*(.+)$/m);

              if (dataMatch) {
                const parsedData = JSON.parse(dataMatch[1]);

                if (parsedData.code !== 0) {
                  const error = new Error(parsedData.message || "Streaming error");
                  onError && onError(error);
                  throw error;
                }

                if (parsedData.data === null) {
                  // This is a thinking state - notify the callback
                  onMessage && onMessage({ content: "", isThinking: true, thinkingMessage: parsedData.message || "" });
                } else if (parsedData.data != null) {
                  // This is the final response
                  onComplete && onComplete(parsedData);
                  return parsedData;
                }
              }
            } catch (parseError) {
              console.error("Error parsing streaming data:", parseError);
            }
          }
        }
      }
    } finally {
      reader.releaseLock();
    }
  } catch (error) {
    console.error("Streaming error:", error);
    onError && onError(error);
    throw error;
  }
};
